import React from "react";
import {
  Paragraph,
  Modal,
  useMediaQuery,
  breakpoints,
  useTheme
} from "@tvg/design-system";
import { get } from "lodash";
import { ContentContainer } from "./styled-components";

type Message = {
  text: string;
  title?: string;
};

export type Messages = {
  [key in string]: Array<Message>;
};

export interface CancellationRulesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBack?: () => void;
  hasBack?: boolean;
  userLocation: string;
  messages: Messages;
}

const CancellationRulesModal = ({
  isOpen,
  onClose,
  hasBack = false,
  onBack,
  userLocation,
  messages
}: CancellationRulesModalProps) => {
  const { space } = useTheme();
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const content: Message[] = get(messages, userLocation, messages.DEFAULT);

  const modalProps = hasBack ? { onBack } : {};

  return (
    <Modal
      isOpen={isOpen}
      title="Wager cancellations"
      type={isMobile ? "flexible" : "lightbox"}
      onClose={onClose}
      {...modalProps}
    >
      <>
        {content?.map(({ title, text }, index) => (
          <ContentContainer space={space} key={index.toString()}>
            {title && (
              <Paragraph
                fontFamily="medium"
                qaLabel="wager-cancellations-title"
                color="grey.900"
              >
                {title}
              </Paragraph>
            )}
            {text && (
              <Paragraph qaLabel="wager-cancellations-text" color="grey.800">
                {text}
              </Paragraph>
            )}
          </ContentContainer>
        ))}
      </>
    </Modal>
  );
};

export default CancellationRulesModal;
